import script from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayout.vue?vue&type=style&index=0&id=92db0f46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92db0f46"]])

export default __exports__